import loadable from "@loadable/component";
import App from "App";
import { PATH, userPath } from "constants/path";
import { DefaultLayout } from "layouts/mobile/DefaultLayout";
import PromotionDevelopPage from "pages/common/PromotionDevelopPage";
import PromotionPage from "pages/common/PromotionPage";
import VipDetails from "pages/desktop/VipDetails";
import AgentApplyPage from "pages/mobile/AgentApplyPage";
import BettingHistoryPage from "pages/mobile/BettingHistoryPage";
import ChangePasswordWithdrawMobile from "pages/mobile/ChangePasswordWithdraw";
import ForgetPassword from "pages/mobile/ForgetPassword";
import MemberCenterPage from "pages/mobile/MemberCenterPage";
import MFavouriteGamePage from "pages/mobile/MFavouriteGamePage";
import MForgotPassByPhone from "pages/mobile/MForgotPassByPhone";
import { MMessagePage } from "pages/mobile/MMessagePage";
import MSecuritySettingPage from "pages/mobile/MSecuritySettingPage";
import SignupPage from "pages/mobile/SignupPage";
import TransactionsMobilePage from "pages/mobile/Transactions";
import VipDetailMobile from "pages/mobile/VipDetails";
import { RouteObject } from "react-router-dom";

import ProtectedRoute from "./protected";

const HomePage = loadable(() => import("pages/mobile/HomePage"));
const FinancialPage = loadable(() => import("pages/mobile/FinancialPage"));
const GamePage = loadable(() => import("pages/mobile/Game"));
const SigninPage = loadable(() => import("pages/mobile/SigninPage"));
const RefundPage = loadable(() => import("pages/mobile/RefundPage"));
const NotificationPage = loadable(() => import("pages/mobile/Notification"));
const MemberVipPage = loadable(() => import("pages/mobile/MMemberVipPage"));
const HistoryVipPage = loadable(() => import("pages/mobile/HistoryVip"));
const AwardVip = loadable(() => import("pages/mobile/AwardVip"));

export const MobileRoutes: RouteObject[] = [
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: PATH.Account.login,
        element: <SigninPage />,
      },
      {
        path: PATH.Account.register,
        element: <SignupPage />,
      },
      {
        path: PATH.Account.forgetPassword,
        element: <ForgetPassword />,
      },

      {
        element: <DefaultLayout />,
        children: [
          {
            path: PATH.Home,
            element: <HomePage />,
          },
          { path: "/AgentApply", element: <AgentApplyPage /> },
          {
            path: PATH.User.Financial,
            element: <FinancialPage />,
          },
          {
            path: PATH.Promotion,
            element: <PromotionPage />,
          },

          //
          {
            path: "/promotion/develop",
            element: <PromotionDevelopPage />,
          },
          //

          { path: PATH.ProviderPage, element: <GamePage /> },
          { path: PATH.GamePage, element: <GamePage /> },
          {
            path: PATH.Account.forgotPassword,
            element: <MForgotPassByPhone />,
          },

          {
            element: <ProtectedRoute />,
            children: [
              {
                path: userPath,
                element: <MemberCenterPage />,
              },
              {
                path: PATH.User.changePasswordWithdraw,
                element: <ChangePasswordWithdrawMobile />,
              },
              {
                path: PATH.User.Event,
                element: <PromotionPage />,
              },
              {
                path: PATH.User.SecuritySetting,
                element: <MSecuritySettingPage />,
              },
              {
                path: PATH.User.BettingHistory,
                element: <BettingHistoryPage />,
              },
              {
                path: PATH.User.Transactions,
                element: <TransactionsMobilePage />,
              },
              {
                path: PATH.User.HistoryUpdateVip,
                element: <HistoryVipPage />,
              },
              {
                path: PATH.User.AwardVip,
                element: <AwardVip />,
              },
              {
                path: PATH.User.Refund,
                element: <RefundPage />,
              },
              {
                path: PATH.User.InternalMail,
                element: <MMessagePage />,
              },
              {
                path: PATH.User.FavouriteGame,
                element: <MFavouriteGamePage />,
              },
              {
                path: PATH.User.Notification,
                element: <NotificationPage />,
              },
              {
                path: PATH.User.MemberVipDetail,
                element: <VipDetailMobile />,
              },
              {
                path: PATH.User.MemberVip,
                element: <MemberVipPage />,
              },
              {
                path: PATH.User.MemberVipDetail,
                element: <VipDetails />,
              },
            ],
          },
        ],
      },
    ],
  },
];
